export enum NotificationBannerIdEnum {
    ClaimYearsInsuranceCoverage = 'SJVD',   // Schadevrije jaren verzekering Dekking
    ClaimYearsInsuranceUpload = 'SJVU',     // Schadevrije jaren verzekering Upload
    InsuranseStartdate = 'VZKI',            // Verzekering Ingangsdatum
    CustomerResearch = 'CSRH',            // Klantonderzoek
}
